import * as Html from "../../util/Html.ts";
import Icons from "../../svg/Icons.ts";
export {init}
Html.registerWidget('widget/form/password',{init:init})

function init(elem){
  elem.css('position','relative');
  var 
    input = elem.find('input'),
    deltaTop = input.position().top+parseInt(input.css("marginTop").replace('px', ''))+(input.outerHeight()-24)/2,
    deltaLeft = input.position().left+parseInt(input.css("marginLeft").replace('px', ''))+input.outerWidth()-34,
    icon = $('<icon style="position:absolute;top:'+deltaTop+'px;left:'+deltaLeft+'px;cursor:pointer;color:#999">'+Icons.ic_eye_off+'</icon>');

  elem.append(icon);
  
  icon.on('click',function(evt){
    evt.stopPropagation();
    evt.preventDefault();
    if(input.attr("type")==="password"){
      icon.html(Icons.ic_eye.toString())
      input.attr('type','text')
    }else{
      icon.html(Icons.ic_eye_off.toString())
      input.attr('type','password')
    }
    input.focus();
    
  })
}